<template>
  <div>
    <div class="grid">
      <div class="grid__col grid__col--12 grid__col--xs-6">

        <label :for="uuid" class="form__label visually-hidden">
          <span class="form__label__text">{{question.label}}</span>
        </label>
        <div class="singleline-form clearfix hero-form form form-wrapper">
          <div class="js-form-item form-item js-form-type-tel form-type-tel js-form-item-cvr form-item-cvr form-no-label form__field form__field--tel form__field--cvr">
            <input
              :placeholder="t('QuestionsCvrInputPlaceholder')"
              pattern="[0-9]{8,8}"
              :title="t('QuestionsCvrInputTitle')"
              class="form__item form-tel required"
              type="tel"
              name="cvr"
              value=""
              size="30"
              maxlength="128"
              required="required"
              aria-required="true"
              ref="cvr"
              :id="uuid"
              v-model.trim="store.cvr"
              @keyup.enter="doFindInsuranceSolution"
            >
          </div>
          <input
            type="submit"
            :title="question.buttons[0].label"
            :value="question.buttons[0].label"
            v-if="question.buttons[0]"
            ref="btnFind"
            class="search-submit button js-form-submit form-submit button--primary tealiumSubmit"
            :class="[question.buttons[0].class, {'is-disabled':!isValid}, {'in-progress': isLoading}]"
            :data-tealium="question.buttons[0]['data-tealium']"
            :disabled="!isValid || isLoading"
            @click="doFindInsuranceSolution"
          >
          <div v-if="isLoading" class="ajax-progress ajax-progress-throbber">
            <div class="throbber">&nbsp;</div>
          </div>
          <div class="form__notice" v-html="t('QuestionsCvrNoticeHtml')">
          </div>
        </div>
        <p>&nbsp;</p>
        <div v-if="noCompanyFound">
          <p>{{t('QuestionsCvrNoCompanyFoundHeadline')}}</p>
          <div role="contentinfo" aria-label="Fejlbesked" class="contentinfo">
            <div role="alert">
              <h2 class="visually-hidden">{{t('QuestionsCvrNoCompanyFoundHeadline')}}</h2>
              <ul class="messages__list">
                <li class="messages__item">{{t('QuestionsCvrNoCompanyFoundMessage')}}</li>
              </ul>
            </div>
          </div>
        </div>
        <div v-else>
          <div v-if="company">
            <p>{{t('QuestionsCvrCompanyFoundHeadline')}}</p>
            <div class="contentinfo">
              <div>
                {{company.name}}
              </div>
              <div>
                {{company.address}}
              </div>
              <div>
                {{company.postalCode}}
                {{company.city}}
              </div>
              <div>
                {{t('QuestionsCvrCompanyFoundCvrLabel')}} {{company.cvr}}
              </div>
            </div>
            <div class="form__field">
                <button
                  v-if="question.buttons[1]"
                  class="button button--primary"
                  :class="[question.buttons[1].class]"
                  :data-tealium="question.buttons[1]['data-tealium']"
                  @click="doNext"
                  ><span>{{question.buttons[1].label}}</span></button>
            </div>
          </div>
        </div>
      </div>
      <div class="grid__col mobile-hide" v-if="this.store.resources.QuestionsCvrInfoBoxHeadline">
        <aside class="rich-text pa-2 c--grey-4">
          <h4>{{t('QuestionsCvrInfoBoxHeadline')}}</h4>
          <div v-html="t('QuestionsCvrInfoBoxContentHtml')">
          </div>
        </aside>
      </div>
    </div>

  </div>
</template>

<script>
import t from './../../../mixins/t.js'
const uuidv4 = require('uuid/v4')

export default {
  name: 'QuestionsCvr',
  props: {
    question: {
      type: Object
    },
    company: {
      type: Object
    }
  },
  mixins: [t],
  data () {
    return {
      store: this.$parent.$parent.store,
      uuid: null,
      isLoading: false
    }
  },
  watch: {
    'noCompanyFound' () {
      if (this.noCompanyFound) {
        this.isLoading = false
      }
    },
    'company' () {
      if (this.company) {
        this.isLoading = false
      }
    }
  },
  computed: {
    isValid () {
      return this.store.cvr
    },
    noCompanyFound () {
      return this.store.noCompanyFound
    },
    buttonSearchPrimary () {
      return (this.store.noCompanyFound || !this.company)
    }
  },
  mounted () {
    this.uuid = uuidv4()
  },
  methods: {
    // Events
    doNext () {
      this.isLoading = false
      this.$emit('next')
    },
    doFindInsuranceSolution () {
      this.isLoading = true
      this.$refs.btnFind.blur()
      this.$set(this.store, 'company', null)
      this.$nextTick(() => this.$emit('find'))
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.contentinfo {
  background:#ededed;
  border:1px solid #e7e7e7;
  margin:.5em 0 1em 0;
  padding:.5em;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/questions/QuestionsCvr.vue